import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
  params?: string | null
}

export const getListRedemption = async (search: any, page: any, filter: Filter) => {
  let url = `${API_URLS}/redemptions?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter?.type) url += `filters${filter.field}=${filter.type}`
  if (filter?.params) url += filter.params
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListRedemptionByMemberId = async (id: any) => {
  let url = `${API_URLS}/redemptions?populate=*&filters[member][id][$eq]=${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const exportRedemption = async () => {
  let url = `${API_URLS}/redemptions?populate=*&`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteRedemptionById = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/redemptions/${id}`)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailRedeemptions = async (id: any) => {
  let url = `${API_URLS}/redemptions/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postRedemption = async (data: any) => {
  try {
    const response = await axios.post(`${API_URLS}/redemptions/add`, {
      form: {
        member_id: parseInt(data.member),
        reward_id: parseInt(data.reward),
        voucher_code: data.code,
        status: data.status,
        date: data.date,
      },
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putRedemption = async (data: any) => {
  try {
    const response = await axios.put(`${API_URLS}/redemptions/${data.id}`, {
      form: {
        member_id: parseInt(data.form.member),
        reward_id: parseInt(data.form.reward),
        voucher_code: data.form.code,
        // total_point: 100000,
        // point_reduction: 1000,
        status: data.form.status,
      },
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postRedemptionVoucher = async (data: any) => {
  try {
    const response = await axios.post(`${API_URLS}/redemptions/send-coupon`, {
      "memberId": data?.attributes?.member?.data?.id,
      "couponId" : data?.attributes?.reward_detail?.data?.id,
      "redemptionId": data?.id
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}